var _path;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgCaretRight(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 256 512",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M248.48 238.551L104.48 102.551C99.936 98.26 94.008 96 87.996 96C74.836 96 64 106.668 64 120V392C64 405.314 74.82 416 87.996 416C94.008 416 99.936 413.74 104.48 409.447L248.48 273.447C253.279 268.914 256 262.604 256 256S253.279 243.084 248.48 238.551ZM237.494 261.816L93.494 397.816C92.004 399.225 90.051 400 87.996 400C83.588 400 80 396.41 80 392V120C80 115.588 83.588 112 87.996 112C90.051 112 92.004 112.775 93.494 114.184L237.492 250.182C239.086 251.688 240 253.809 240 256S239.086 260.312 237.494 261.816Z"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgCaretRight);
export default __webpack_public_path__ + "static/media/caret-right.1131b6d1a87460b54aa1a3d2c970b612.svg";
export { ForwardRef as ReactComponent };